// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { Col, Row } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { QuickNumbers } from '../Component/Dashboard/QuickNumbers';
// import { LastComments } from '../Component/Dashboard/LastComments';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_All_Company_Profile } from '../Redux/Actions/Company_Profile_Action';
// import { QuickNumbersForMarketer } from '../Component/Dashboard/QuickNumbersForMarketer';
// import { useMediaQuery, useTheme } from '@mui/material';

// export const Dashboardpage = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const refreshleads = (e) => {
//     localStorage.removeItem('stagestorage');
//     userlogin.data.role === 'Admin'
//       ? navigate('/AllLeadsForAdmin')
//       : navigate('/ALLLeadsForMarketer');

//     // navigate("/AllLeads");
//   };

//   useEffect(() => {
//     const getcompanyinformation = async () => {
//       await dispatch(Get_All_Company_Profile());
//     };
//     getcompanyinformation();
//   }, []);

//   const resgetall = useSelector((state) => state.AllCompanyProfile.CompanyProfile);
//   let AllCompanyprofile = Array.isArray(resgetall?.data) ? resgetall.data : [];
//   const profile = AllCompanyprofile[0]; // Assuming one profile only
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

//   return (
//     <div
//       style={{
//         display: 'flex',
//         flexDirection: 'column',
//         minHeight: '100vh',
//         marginTop: isSmallScreen ? '120px' : isMediumScreen ? '30px' : '50px',
//         // marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//         padding: isSmallScreen ? '10px' : '20px',
//         backgroundColor: mode === 'dark' ? '#121212' : '#f5f5f5',
//         position: 'relative',
//       }}
//     >
//       <Row className="dashboard-row " style={{ marginTop: '22px' }}>
//         <Col xs={12} md={1} lg={1} className="sidebar-col"></Col>
//         <Col xs={12} md={11} lg={11} className="main-content-col">
//           <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
//             <div onClick={refreshleads} style={{ textDecoration: 'none', color: '#102dff' }}>
//               <span style={{ fontWeight: 'bold', cursor: 'pointer' }}>Leads</span>
//             </div>
//             <KeyboardDoubleArrowRightIcon />
//             <span style={{ color: '#666' }}>Dashboard</span>
//           </div>

//           <div className="my-3">
//             <div className="title_container_dashboard" style={{ fontSize: '20px' }}>
//               Hello {userlogin?.data?.name} 👋
//             </div>
//             <div className="title_container_dashboard">
//               Welcome To {profile?.description || 'Company Description'}
//             </div>
//             <div style={{ fontSize: '12px' }} className="title_container_dashboard">
//               We Hope You Love Our Design.
//             </div>
//           </div>

//           <hr />

//           {userlogin?.data?.role === 'Admin' ? (
//             <QuickNumbers />
//           ) : userlogin?.data?.role === 'Marketer' ? (
//             <QuickNumbersForMarketer />
//           ) : null}
//           {userlogin?.data?.role === 'Admin' ? <LastComments /> : null}
//         </Col>
//       </Row>
//       <div style={{ marginBottom: '150px' }}>{/* آخر عنصر أو Wrapper للصفحة كلها */}</div>
//     </div>
//   );
// };

















// 20-5-2026
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { QuickNumbers } from '../Component/Dashboard/QuickNumbers';
import { LastComments } from '../Component/Dashboard/LastComments';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Company_Profile } from '../Redux/Actions/Company_Profile_Action';
import { QuickNumbersForMarketer } from '../Component/Dashboard/QuickNumbersForMarketer';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

// const EXPANDED_WIDTH  = 242;
// const COLLAPSED_WIDTH = 64;

export const Dashboardpage = () => {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const theme     = useTheme();
  const mode      = theme.palette.mode;
  const isMobile  = useMediaQuery(theme.breakpoints.down('md'));

  const [userlogin,     setuserlogin]     = useState('');
  // const [sidebarWidth,  setSidebarWidth]  = useState(EXPANDED_WIDTH);
const sidebarWidth = useSidebarWidth();
  /* ── listen for sidebar toggle ── */
  // useEffect(() => {
  //   const handler = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', handler);
  //   return () => window.removeEventListener('sidebarResized', handler);
  // }, []);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setuserlogin(JSON.parse(u));
  }, []);

  const refreshleads = () => {
    localStorage.removeItem('stagestorage');
    userlogin?.data?.role === 'Admin'
      ? navigate('/AllLeadsForAdmin')
      : navigate('/ALLLeadsForMarketer');
  };

  useEffect(() => {
    dispatch(Get_All_Company_Profile());
  }, [dispatch]);

  const resgetall        = useSelector((s) => s.AllCompanyProfile.CompanyProfile);
  const AllCompanyprofile = Array.isArray(resgetall?.data) ? resgetall.data : [];
  const profile          = AllCompanyprofile[0];

  /* ── layout ── */
  const ml = isMobile ? 0 : sidebarWidth;

  return (
    <div
      style={{
        marginLeft      : ml,
        transition      : 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
        minHeight       : '100vh',
        backgroundColor : mode === 'dark' ? '#121212' : '#F7F8FC',
        padding         : isMobile ? '16px' : '32px 32px 80px',
        boxSizing       : 'border-box',
      }}
    >
      {/* breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 20,marginTop:40}}>
        <span
          onClick={refreshleads}
          style={{ fontWeight: 600, cursor: 'pointer', color: '#1A3ECF', fontSize: 13 }}
        >
          Leads
        </span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 16, color: '#7B829A' }} />
        <span style={{ color: '#7B829A', fontSize: 13 }}>Dashboard</span>
      </div>

      {/* greeting */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{
          margin       : 0,
          fontSize     : 22,
          fontWeight   : 700,
          color        : mode === 'dark' ? '#fff' : '#1C2340',
          fontFamily   : "'DM Sans', sans-serif",
        }}>
          Hello {userlogin?.data?.name} 👋
        </h1>
        <p style={{ margin: '4px 0 0', color: '#7B829A', fontSize: 13 }}>
          {profile?.description || 'Welcome to your CRM Dashboard'}
        </p>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid #E8EAF0', marginBottom: 28 }} />

      {/* quick numbers */}
      {userlogin?.data?.role === 'Admin'    && <QuickNumbers />}
      {userlogin?.data?.role === 'Marketer' && <QuickNumbersForMarketer />}

      {/* comments / analysis */}
      {userlogin?.data?.role === 'Admin' && <LastComments />}
    </div>
  );
};
